import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { savedMessagesActions } from '../../actions';
import {
  FillSaveMessageActionPayload,
  SaveMessageActionPayload,
} from '../../typedefs';
import { projectsActions } from '@bus/projects/actions';
import { fetchSavedProjects } from '@bus/savedMessages/saga/workers/fetchSavedProjects';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';

export function* saveMessage({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<SaveMessageActionPayload>) {
  try {
    yield effects.put(savedMessagesActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: `messages/${payload.message_id}/save`, body },
    ]);
    if (!response.ok) {
      reject();
      yield throwError(response);
    }
    const data: FillSaveMessageActionPayload = yield effects.call([
      response,
      'json',
    ]);

    yield effects.put(projectsActions.saveMessage(data));
    yield effects.call(fetchSavedProjects);

    resolve();
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(savedMessagesActions.stopFetching());
  }
}
